export default "__VITE_ASSET__Dwr1wU$9__"